import React, { useMemo } from 'react';
import cx from 'classnames';
import { isEmpty } from 'lodash/lang';

import Common from '../../../../../../../../common/common';
import Checkbox from '../../../../../../../../common/data-entry/InputSelectors/Checkbox';

import './LogCheckItemGroupContent.scss';

export default function LogItemGroupContent({ logCheckSnapshotState }) {
  const logChecksToRender = useMemo(() => prepareLogChecksToRender(logCheckSnapshotState), [logCheckSnapshotState]);

  return (
    !isEmpty(logChecksToRender) && (
      <div className="eds-review-item-group-element-table-reflection">
        <div className="log-check-title">
          <span>Log Check</span>
        </div>
        <div className="log-check-data-about">
          <span>{logCheckSnapshotState?.logCheckSnapshot.whoDidItName}</span>
          <span>{Common.formatDate(logCheckSnapshotState?.logCheckSnapshot.whenWasItDone)}</span>
        </div>

        <div className="log-check-items">
          {logChecksToRender.map((answer, index) => {
            return (
              <div className="log-check-item" key={index}>
                {answer.isNotPerformed && (
                  <div className="log-check-question">
                    <div className="log-check-np-item">
                      <span className="log-check-np-header">Not Performed:</span>
                      <span className="log-check-np-reason">{answer.notPerformedReason}</span>
                    </div>
                  </div>
                )}
                {!answer.isNotPerformed && (
                  <>
                    <div className="log-check-question">
                      <div className="edited-answer-layout">
                        <div className={cx({ 'change-bullet': answer.edited })} />
                        <div className="log-check-question-value">{answer.logCheckValue}</div>
                      </div>
                    </div>
                    <div className="log-check-answer">
                      <Checkbox checked={answer.checked} disabled />
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    )
  );
}

function prepareLogChecksToRender(logCheckSnapshotState) {
  return logCheckSnapshotState?.logCheckSnapshot.logCheckAnswers.map(e => {
    return {
      ...e,
      isNotPerformed: logCheckSnapshotState?.logCheckSnapshot.notPerformed,
      notPerformedReason: logCheckSnapshotState?.logCheckSnapshot.reasonCommentForNotPerformed
    };
  });
}
